
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetobhimashankarinnovacrysta() {



    const cardData =
    {
        keyword: 'Pune to Bhimashankar Innova Crysta Taxi Service',
        heading: 'Meghana Cab : Pune to Bhimashankar Innova Crysta Taxi Service',
        headingDescription: 'Meghana Cab offers Pune to Bhimashankar Innova Crysta Taxi Service, providing a luxurious, safe, and serene pilgrimage journey to the revered Bhimashankar Jyotirlinga. Covering approximately 110–125 km via scenic ghat roads in about 2.5–3.5 hours, our Innova Crysta cabs ensure a comfortable ride with plush leather seats, ample legroom, air-conditioning, and sufficient luggage space . Whether you are planning a one-day darshan, spiritual retreat, or a group trip, our professional chauffeurs know the best routes and stops along the way. Featuring door-to-door pickups from anywhere in Pune, GPS-enabled vehicles, flexible booking options (one-way, round-trip, or hourly), and 24/7 customer support, Meghana Cab guarantees a smooth, dignified, and worry-free journey to Bhimashankar.',


        top: 'Top Places to Visit in Bhimashankar with Meghana Cab',

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description": "A revered Shiva shrine and one of the 12 Jyotirlingas, built in 13th-century Nagara style and expanded by Nana Phadnavis and Chimaji Appa. The temple houses the sacred Shawambhu lingam, antique Portuguese bell, and sits at 934 m above sea level on the banks of the Bhima River."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Covering 131 km² of Western Ghats forest, this sanctuary protects the endemic Indian giant squirrel and supports leopards, deer, pangolins, and hornbills. Popular weekend getaway for safaris, guided nature treks, and bird-watching."
  },
  {
    "title": "Hanuman Lake",
    "description": "A tranquil mountain lake located ~2 km from the temple, shaded by forest and lined with benches—ideal for picnics, bird-watching, and quiet reflection."
  },
  {
    "title": "Gupt Bhimashankar Cave",
    "description": "An offbeat cave shrine associated with the original Jyotirlinga legend, reached via a 1–2 km trek through forest—offering a peaceful meditative retreat."
  },
  {
    "title": "Ahupe Waterfall",
    "description": "A seasonal waterfall a short drive from the temple, vibrant during monsoon rains; perfect for a refreshing dip and nature photography."
  },
  {
    "title": "Bhorgiri Fort",
    "description": "A hill-fort perched at ~2,000 ft, north of Bhimashankar. The trek takes you through evergreen forest to ruins, rock-cut caves, and panoramic views of the Bhima valley."
  },
  {
    "title": "Trekking Trails (Ganesh & Sidi Ghats)",
    "description": "Trailheads from Khandas village lead through steep forested Ghats to the temple. Longer treks connect Bhorgiri, Gupt Bhimashankar, and Nagphani Point."
  },
  {
    "title": "Nearby Shiva Shrines & Sacred Tirthas",
    "description": "Within the temple precinct are Moksha‑Kund, Sarva‑Tirtha (river’s origin), Shani Mandir, Datta Mandir and other minor shrines, each with spiritual lore."
  },
  {
    "title": "Detours: Shivneri & Baneshwar",
    "description": "Extend your visit with nearby hill forts—Shivneri (birthplace of Shivaji) and Baneshwar temple in forested surroundings—both under 50 km away."
  }
],

    "services": [
    {
      "name": "Pune to Bhimashankar Innova Crysta Cab Booking",
      "description": "Book a premium Innova Crysta cab from Pune to Bhimashankar for a serene and comfortable pilgrimage. Enjoy smooth rides, professional chauffeur service, and the convenience of doorstep pickup as you travel to one of Maharashtra’s most revered Jyotirlinga shrines."
    },
    {
      "name": "One Way Innova Crysta Pune Bhimashankar",
      "description": "Opt for our one-way Innova Crysta taxi service from Pune to Bhimashankar, ideal for those planning a short stay or looking for flexibility in their return travel. Affordable, efficient, and convenient for solo or group travelers."
    },
    {
      "name": "Round Trip Innova Crysta Pune Bhimashankar",
      "description": "Make your journey stress-free with a round trip Innova Crysta booking from Pune to Bhimashankar and back. Ideal for families and pilgrims, this package includes flexible return schedules and the comfort of traveling in the same vehicle both ways."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Bhimashankar",
      "description": "Travel in total comfort with our fully air-conditioned Innova Crysta taxis. Perfect for navigating the hilly terrain and forest routes to Bhimashankar, especially during summer or monsoon."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Bhimashankar",
      "description": "Relax as our experienced chauffeur drives you from Pune to Bhimashankar. Expect courteous behavior, safe driving, and deep knowledge of the route and local stops en route to the temple."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Bhimashankar",
      "description": "Get the privacy and flexibility of a private Innova Crysta cab. Ideal for spiritual seekers, families, and small groups who prefer an exclusive ride without ride-sharing hassles."
    },
    {
      "name": "Online Booking Innova Crysta Pune Bhimashankar",
      "description": "Book your Pune to Bhimashankar Innova Crysta cab online in minutes. Enjoy real-time availability, instant confirmation, transparent pricing, and flexible scheduling—all at your fingertips."
    },
    {
      "name": "Bhimashankar Pilgrimage Innova Crysta",
      "description": "Make your pilgrimage memorable with our specially curated Bhimashankar travel packages in an Innova Crysta. Comfortable for elders and children alike, with stops at key spiritual landmarks en route."
    },
    {
      "name": "Comfortable Innova Crysta Cab Pune Bhimashankar",
      "description": "Experience a comfortable and peaceful journey with reclining seats, spacious legroom, and smooth suspension in our well-maintained Innova Crysta—ideal for the winding roads to Bhimashankar."
    },
    {
      "name": "Budget Innova Crysta Taxi Pune Bhimashankar",
      "description": "Our budget Innova Crysta taxi service offers a cost-effective way to reach Bhimashankar without compromising on quality, safety, or comfort."
    },
    {
      "name": "Religious Tour Innova Crysta Pune",
      "description": "Planning a temple or spiritual circuit around Pune? Include Bhimashankar in your itinerary with our religious tour Innova Crysta packages, designed for comfort and convenience during sacred travel."
    },
    {
      "name": "Family Trip Innova Crysta Bhimashankar",
      "description": "Travel with your family in comfort and safety. Our Innova Crysta offers space for 6-7 passengers, child-friendly features, and ample luggage space—ideal for family outings to Bhimashankar."
    },
    {
      "name": "Reliable Innova Crysta Taxi Bhimashankar",
      "description": "Count on our punctuality, well-maintained cabs, and courteous drivers to ensure a reliable ride from Pune to Bhimashankar. We prioritize customer safety and satisfaction."
    },
    {
      "name": "Long Distance Innova Crysta Taxi",
      "description": "Our Innova Crysta cabs are optimized for long-distance routes like Pune to Bhimashankar. Enjoy robust engine performance, clean interiors, and steady rides across various terrains."
    },
    {
      "name": "Weekend Trip Innova Crysta Bhimashankar",
      "description": "Perfect for a spiritual weekend escape, our Innova Crysta weekend trip package to Bhimashankar includes timely pickup, smooth drives, and full-day availability for a fulfilling temple visit."
    }
  ],
  "tableData": [
    ["Pune to Bhimashankar Innova Crysta Cab Booking", "One Way Innova Crysta Pune Bhimashankar"],
    ["Round Trip Innova Crysta Pune Bhimashankar", "AC Innova Crysta Taxi Pune Bhimashankar"],
    ["Chauffeur Driven Innova Crysta Pune Bhimashankar", "Private Innova Crysta Taxi Pune Bhimashankar"],
    ["Online Booking Innova Crysta Pune Bhimashankar", "Bhimashankar Pilgrimage Innova Crysta"],
    ["Comfortable Innova Crysta Cab Pune Bhimashankar", "Budget Innova Crysta Taxi Pune Bhimashankar"],
    ["Religious Tour Innova Crysta Pune", "Family Trip Innova Crysta Bhimashankar"],
    ["Reliable Innova Crysta Taxi Bhimashankar", "Long Distance Innova Crysta Taxi"],
    ["Weekend Trip Innova Crysta Bhimashankar", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Taxi from Pune to Bhimashankar",
    "WhyChoosedescription": "Book our Innova Crysta taxi for a comfortable and reliable journey from Pune to Bhimashankar—one of Maharashtra’s most revered Jyotirlinga temples. Enjoy a smooth ride through scenic ghats and forest routes, perfect for pilgrimages and family travel."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable for Hill Travel",
    "WhyChoosedescription": "The Innova Crysta offers seating for 6–7 passengers, with reclining seats, powerful dual AC, and ample luggage space. It's ideal for navigating hilly terrain while keeping passengers comfortable throughout the 110+ km route."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Ghat and Temple Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with the curvy roads and ghat sections leading to Bhimashankar. They ensure safe, smooth driving and assist with temple drop-offs and local travel guidance."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "Our Innova Crysta taxis are regularly cleaned and fully sanitized before every trip. We maintain top hygiene and vehicle performance standards to ensure a peaceful journey for all passengers."
  },
  {
    "WhyChooseheading": "Flexible Booking Options – Round Trip or Same-Day Return",
    "WhyChoosedescription": "Choose from one-way, same-day return, or overnight stay options. We customize the itinerary based on your darshan timing, preferred stops, and travel schedule."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our Pune to Bhimashankar packages include fuel, tolls, driver allowance, and taxes. Get clear, all-inclusive pricing upfront—perfect for planning your trip with no last-minute surprises."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimages, Nature Trips, and Family Outings",
    "WhyChoosedescription": "Bhimashankar is not just a religious destination—it's also part of a wildlife sanctuary. Our Innova Crysta taxis are perfect for families and groups looking to enjoy both spiritual peace and natural beauty."
  },
  {
    "WhyChooseheading": "24/7 Booking Support and Personalized Assistance",
    "WhyChoosedescription": "Our customer support team is available round-the-clock to assist with bookings, itinerary changes, and special travel requests. Enjoy a smooth, stress-free cab experience from Pune to Bhimashankar."
  }
]






















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta taxi from Pune to Bhimashankar?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or via our website for quick and easy booking."
    },
    {
        question: "What is the distance and travel time from Pune to Bhimashankar?",
        answer: "Bhimashankar is approximately 110 km from Pune, with a travel time of around 3 to 4 hours depending on traffic and road conditions."
    },
    {
        question: "Is the Innova Crysta suitable for the Pune to Bhimashankar trip?",
        answer: "Yes, the Innova Crysta offers spacious seating and comfortable ride, ideal for the hilly terrain and longer drives."
    },
    {
        question: "Can I hire the Innova Crysta taxi for a round trip to Bhimashankar?",
        answer: "Yes, both one-way and round-trip rental options are available."
    },
    {
        question: "How many passengers can the Innova Crysta accommodate?",
        answer: "The Innova Crysta comfortably seats 6 to 7 passengers with sufficient luggage space."
    },
    {
        question: "Are the vehicles sanitized before every trip?",
        answer: "Yes, all vehicles are thoroughly sanitized before each journey to ensure passenger safety."
    },
    {
        question: "Can I request stops for sightseeing or meals during the trip?",
        answer: "Yes, you can request stops along the way for sightseeing, meals, or breaks."
    },
    {
        question: "What is included in the Pune to Bhimashankar taxi fare?",
        answer: "The fare includes fuel, driver charges, and tolls. Additional waiting time or parking fees may incur extra costs."
    },
    {
        question: "Are the drivers experienced with routes to Bhimashankar?",
        answer: "Yes, our drivers are knowledgeable about the route and local conditions to ensure a safe journey."
    },
    {
        question: "What payment methods are accepted for booking?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ajay Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Innova Crysta made our trip to Bhimashankar comfortable and safe. The driver was punctual and courteous.”',
    },
    {
        name: 'Ms. Shweta Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service for a day trip to Bhimashankar. The car was clean and spacious, perfect for our group.”',
    },
];



































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];





const puneToBhimashankarSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Bhimashankar Innova Crysta Taxi Service",
  "description": "Book chauffeur-driven Innova Crysta for Pune to Bhimashankar travel. Ideal for religious trips, family travel, and weekend getaways. AC, comfortable, and reliable cab service with online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Pilgrimage Taxi Service",
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Bhimashankar"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-bhimashankar-innova-crysta-cab"
  }
};









    return (
        <div>

<Helmet>
  <title>Pune to Bhimashankar Innova Crysta Taxi | Cab Booking Service</title>
  <meta
    name="description"
    content="Book Pune to Bhimashankar Innova Crysta cab for religious travel, family pilgrimage, or weekend trips. Comfortable chauffeur-driven AC taxi with online booking and affordable rates."
  />
  <meta
    name="keywords"
    content="Pune to Bhimashankar Innova Crysta Cab Booking, One Way Innova Crysta Pune Bhimashankar, Round Trip Innova Crysta Pune Bhimashankar, AC Innova Crysta Taxi Pune Bhimashankar, Chauffeur Driven Innova Crysta Pune Bhimashankar, Private Innova Crysta Taxi Pune Bhimashankar, Online Booking Innova Crysta Pune Bhimashankar, Bhimashankar Pilgrimage Innova Crysta, Comfortable Innova Crysta Cab Pune Bhimashankar, Budget Innova Crysta Taxi Pune Bhimashankar, Religious Tour Innova Crysta Pune, Family Trip Innova Crysta Bhimashankar, Reliable Innova Crysta Taxi Bhimashankar, Long Distance Innova Crysta Taxi, Weekend Trip Innova Crysta Bhimashankar"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToBhimashankarSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/9.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetobhimashankarinnovacrysta;